module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-roster-blue-c7d519b6cb2ec01d7d4a31753e1117aa.svg";